
import { useState, useEffect, useRef } from 'react';

type Review = {
  name: string;
  rating: number;
  review: string;
  date: string;
  location: string;
  avatar: string;
};

const reviews: Review[] = [
  {
    name: 'Алия Нурланова',
    rating: 5,
    review: 'Отличный сервис! Стиральная машина перестала отжимать бельё. Мастер приехал в тот же день, быстро нашёл проблему и заменил подшипник. Работает как новая!',
    date: '15 января 2024',
    location: 'Алматы, Бостандыкский район',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20kazakh%20woman%20with%20dark%20hair%20smiling%20warmly%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar-alia-v2&orientation=squarish',
  },
  {
    name: 'Ерлан Сатыбалдиев',
    rating: 5,
    review: 'Посудомоечная машина не грела воду. Позвонил утром, к обеду уже приехал мастер. Оказалось, сгорел ТЭН. Заменили за час, цена адекватная.',
    date: '8 января 2024',
    location: 'Алматы, Медеуский район',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20middle%20aged%20kazakh%20man%20with%20short%20hair%20friendly%20expression%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar-erlan-v2&orientation=squarish',
  },
  {
    name: 'Динара Касымова',
    rating: 5,
    review: 'Сушильная машина начала странно шуметь и плохо сушить. Мастер всё объяснил, почистил фильтры и заменил ремень. Теперь работает тихо и эффективно.',
    date: '22 декабря 2023',
    location: 'Алматы, Алмалинский район',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20central%20asian%20woman%20with%20brown%20hair%20gentle%20smile%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar-dinara-v2&orientation=squarish',
  },
  {
    name: 'Максим Петров',
    rating: 5,
    review: 'Стиральная машина протекала при каждой стирке. Думал, придётся покупать новую. Но мастера заменили манжету люка и всё герметично. Прошло 3 месяца — никаких проблем.',
    date: '5 декабря 2023',
    location: 'Алматы, Ауэзовский район',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20young%20slavic%20man%20with%20light%20hair%20confident%20expression%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar-maxim-v2&orientation=squarish',
  },
  {
    name: 'Гульнара Абдуллаева',
    rating: 5,
    review: 'Посудомойка не включалась вообще. Мастер приехал с запчастями, заменил модуль управления. Всё сделали аккуратно, убрали за собой. Цены честные!',
    date: '18 ноября 2023',
    location: 'Алматы, Наурызбайский район',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20a%20mature%20kazakh%20woman%20with%20elegant%20appearance%20warm%20smile%20natural%20lighting%20clean%20background%20headshot&width=100&height=100&seq=avatar-gulnara-v2&orientation=squarish',
  },
];

export default function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const [headerVisible, setHeaderVisible] = useState(false);
  const [cardVisible, setCardVisible] = useState(false);
  const [statsVisible, setStatsVisible] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const statsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs1 = new IntersectionObserver(([e]) => { if (e.isIntersecting) setHeaderVisible(true); }, { threshold: 0.1 });
    const obs2 = new IntersectionObserver(([e]) => { if (e.isIntersecting) setCardVisible(true); }, { threshold: 0.1 });
    const obs3 = new IntersectionObserver(([e]) => { if (e.isIntersecting) setStatsVisible(true); }, { threshold: 0.1 });
    if (headerRef.current) obs1.observe(headerRef.current);
    if (cardRef.current) obs2.observe(cardRef.current);
    if (statsRef.current) obs3.observe(statsRef.current);
    return () => { obs1.disconnect(); obs2.disconnect(); obs3.disconnect(); };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => nextReview(), 5000);
    return () => clearInterval(interval);
  }, []);

  const nextReview = () => {
    setDirection('right');
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
      setIsTransitioning(false);
    }, 350);
  };

  const prevReview = () => {
    setDirection('left');
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);
      setIsTransitioning(false);
    }, 350);
  };

  const goToReview = (index: number) => {
    if (index !== currentIndex) {
      setDirection(index > currentIndex ? 'right' : 'left');
      setIsTransitioning(true);
      setTimeout(() => {
        setCurrentIndex(index);
        setIsTransitioning(false);
      }, 350);
    }
  };

  const current = reviews[currentIndex];

  const handleAvatarError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = 'https://via.placeholder.com/100?text=No+Image';
  };

  const getTransitionClass = () => {
    if (isTransitioning) {
      return direction === 'right'
        ? 'opacity-0 -translate-x-12 scale-95'
        : 'opacity-0 translate-x-12 scale-95';
    }
    return 'opacity-100 translate-x-0 scale-100';
  };

  return (
    <section id="reviews" className="py-14 md:py-20 bg-gradient-to-b from-gray-50 to-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header — slides up */}
        <div ref={headerRef} className={`text-center mb-10 md:mb-16 transition-all duration-800 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
            Отзывы клиентов
          </h2>
          <div className={`h-1 mx-auto rounded-full bg-gradient-to-r from-teal-500 to-emerald-500 transition-all duration-1000 delay-300 ${headerVisible ? 'w-24' : 'w-0'}`}></div>
          <p className={`text-sm md:text-lg text-gray-600 max-w-2xl mx-auto mt-3 transition-all duration-700 delay-200 ${headerVisible ? 'opacity-100' : 'opacity-0'}`}>
            Узнайте, что говорят наши довольные клиенты о нашем сервисе
          </p>
        </div>

        {/* Review Card — slides in with direction */}
        <div ref={cardRef} className={`relative max-w-4xl mx-auto mb-10 md:mb-16 transition-all duration-800 ${cardVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`} style={{ transitionTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)' }}>
          <div className={`bg-white/80 backdrop-blur-lg rounded-xl md:rounded-2xl shadow-xl md:shadow-2xl p-5 md:p-12 border border-gray-100 transition-all duration-350 ease-out ${getTransitionClass()}`}>
            <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-0 mb-4 md:mb-6">
              <div className="flex items-center">
                <img
                  src={current.avatar}
                  alt={current.name}
                  onError={handleAvatarError}
                  className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover mr-3 md:mr-4 ring-3 md:ring-4 ring-teal-100"
                />
                <div>
                  <h4 className="font-bold text-gray-900 text-sm md:text-lg">{current.name}</h4>
                  <p className="text-xs md:text-sm text-gray-500">{current.location}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 sm:ml-auto">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill text-base md:text-xl ${i < current.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                ))}
              </div>
            </div>
            <p className="text-gray-700 text-sm md:text-lg leading-relaxed mb-4 md:mb-6 italic">
              &ldquo;{current.review}&rdquo;
            </p>
            <div className="flex items-center text-xs md:text-sm text-gray-500">
              <i className="ri-calendar-line mr-1.5 md:mr-2 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center"></i>
              <span>{current.date}</span>
            </div>
          </div>

          {/* Navigation arrows */}
          <button
            onClick={prevReview}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-4 w-9 h-9 md:w-12 md:h-12 bg-white rounded-full shadow-lg md:shadow-xl flex items-center justify-center hover:bg-teal-50 hover:scale-110 transition-all duration-300 cursor-pointer group z-10"
          >
            <i className="ri-arrow-left-s-line text-xl md:text-2xl text-gray-700 group-hover:text-teal-600"></i>
          </button>
          <button
            onClick={nextReview}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-4 w-9 h-9 md:w-12 md:h-12 bg-white rounded-full shadow-lg md:shadow-xl flex items-center justify-center hover:bg-teal-50 hover:scale-110 transition-all duration-300 cursor-pointer group z-10"
          >
            <i className="ri-arrow-right-s-line text-xl md:text-2xl text-gray-700 group-hover:text-teal-600"></i>
          </button>

          {/* Dots */}
          <div className="flex justify-center mt-5 md:mt-8 gap-1.5 md:gap-2">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => goToReview(index)}
                className={`h-2 md:h-2.5 rounded-full transition-all duration-500 cursor-pointer ${
                  index === currentIndex
                    ? 'bg-gradient-to-r from-teal-500 to-emerald-500 w-6 md:w-8'
                    : 'bg-gray-300 w-2 md:w-2.5 hover:bg-gray-400'
                }`}
              ></button>
            ))}
          </div>
        </div>

        {/* Stats cards — staggered scale in */}
        <div ref={statsRef} className="grid grid-cols-3 gap-3 md:gap-8">
          {[
            { icon: 'ri-star-fill', value: '4.9/5', label: 'Средний рейтинг', gradient: 'from-teal-50 to-emerald-50', iconGradient: 'from-teal-500 to-emerald-500', textGradient: 'from-teal-600 to-emerald-600' },
            { icon: 'ri-user-heart-line', value: '5.000+', label: 'Довольных клиентов', gradient: 'from-orange-50 to-amber-50', iconGradient: 'from-orange-500 to-amber-500', textGradient: 'from-orange-600 to-amber-600' },
            { icon: 'ri-thumb-up-line', value: '98%', label: 'Удовлетворённость', gradient: 'from-teal-50 to-cyan-50', iconGradient: 'from-teal-500 to-cyan-500', textGradient: 'from-teal-600 to-cyan-600' },
          ].map((stat, i) => (
            <div
              key={i}
              className={`bg-gradient-to-br ${stat.gradient} rounded-xl shadow-md md:shadow-lg p-4 md:p-6 text-center transform hover:-translate-y-1 md:hover:-translate-y-2 hover:shadow-xl md:hover:shadow-2xl transition-all duration-700 cursor-pointer ${
                statsVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-12 scale-80'
              }`}
              style={{ transitionDelay: `${i * 200}ms`, transitionTimingFunction: 'cubic-bezier(0.34, 1.56, 0.64, 1)' }}
            >
              <div className={`w-10 h-10 md:w-16 md:h-16 bg-gradient-to-br ${stat.iconGradient} rounded-full flex items-center justify-center mx-auto mb-2 md:mb-4 ${statsVisible ? 'animate-bounce-slow' : ''}`} style={{ animationDelay: `${i * 300}ms` }}>
                <i className={`${stat.icon} text-lg md:text-3xl text-white`}></i>
              </div>
              <div className={`text-xl md:text-3xl font-bold bg-gradient-to-r ${stat.textGradient} bg-clip-text text-transparent mb-0.5 md:mb-2`}>
                {stat.value}
              </div>
              <p className="text-[10px] md:text-sm text-gray-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
